module.exports = __webpack_public_path__ + "static/img/eight_icon3.59dedb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/riff/eight_icon3.png
// module id = n86N
// module chunks = 12